import URLConst from '../constants/URLConst'
import { fetchJSON, secureGET } from '../utilities/FetchHelper'

class DashboardSummaryService {

    getDashboardSummary() {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_DASHBOARD_SUMMARY
        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new DashboardSummaryService()